import { useEffect, useState } from "react";
import { Loader2, Landmark } from "lucide-react";
import { toast } from "sonner";
import { admin, inputCls } from "./adminApi";

export function PaymentInstructionsPanel() {
  const [text, setText] = useState("");
  const [wallets, setWallets] = useState({ wallet_btc: "", wallet_usdt: "", wallet_usdt_network: "" });
  const [saved, setSaved] = useState("");
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    admin.get("/admin/settings/payment-instructions")
      .then(r => { setText(r.data.instructions); setSaved(r.data.instructions); setWallets({ wallet_btc: r.data.wallet_btc || "", wallet_usdt: r.data.wallet_usdt || "", wallet_usdt_network: r.data.wallet_usdt_network || "" }); })
      .catch(() => {});
  }, []);

  const save = async () => {
    if (!text.trim()) { toast.error("Instructions can't be empty"); return; }
    setBusy(true);
    try {
      const r = await admin.put("/admin/settings/payment-instructions", { instructions: text, ...wallets });
      setSaved(r.data.instructions);
      toast.success("Payment instructions saved");
      setOpen(false);
    } catch { toast.error("Save failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="border border-white/8 p-5" data-testid="payment-instructions-panel">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-start gap-3 min-w-0">
          <Landmark size={16} className="text-[color:var(--bl-gold)] mt-0.5 shrink-0" />
          <div className="min-w-0">
            <div className="bl-eyebrow text-[color:var(--bl-gold)]">How customers pay</div>
            <div className="text-white/70 text-sm mt-1 whitespace-pre-line line-clamp-3" data-testid="payment-instructions-current">{saved || "…"}</div>
            <div className="font-mono text-[10px] tracking-[0.15em] text-white/40 mt-2 break-all" data-testid="wallets-current">
              BTC: {wallets.wallet_btc || "not set"} · USDT: {wallets.wallet_usdt ? `${wallets.wallet_usdt}${wallets.wallet_usdt_network ? ` (${wallets.wallet_usdt_network})` : ""}` : "not set"}
            </div>
          </div>
        </div>
        <button onClick={() => setOpen(v => !v)} data-testid="payment-instructions-edit" className="bl-btn text-[10px] py-2 px-3">{open ? "Close" : "Edit"}</button>
      </div>
      {open && (
        <div className="mt-4 space-y-3">
          <textarea value={text} onChange={e => setText(e.target.value)} rows={6} data-testid="payment-instructions-input"
            placeholder={"We accept Bitcoin (BTC) and USDT.\nWe'll email your payment request (wallet address + exact amount) within a few hours.\nQuote your order reference when you pay."}
            className={`w-full ${inputCls} px-3 py-3 text-xs leading-relaxed`} />
          <div className="grid sm:grid-cols-3 gap-2">
            <input value={wallets.wallet_btc} onChange={e => setWallets({ ...wallets, wallet_btc: e.target.value })} data-testid="wallet-btc-input" placeholder="BTC receiving address" className={`${inputCls} px-3 py-2.5 text-xs`} />
            <input value={wallets.wallet_usdt} onChange={e => setWallets({ ...wallets, wallet_usdt: e.target.value })} data-testid="wallet-usdt-input" placeholder="USDT receiving address (leave blank for now)" className={`${inputCls} px-3 py-2.5 text-xs`} />
            <input value={wallets.wallet_usdt_network} onChange={e => setWallets({ ...wallets, wallet_usdt_network: e.target.value })} data-testid="wallet-usdt-network-input" placeholder="USDT network e.g. TRC20 / ERC20" className={`${inputCls} px-3 py-2.5 text-xs`} />
          </div>
          <div className="flex justify-between items-center gap-3 flex-wrap">
            <div className="font-mono text-[10px] tracking-[0.2em] text-white/40 uppercase">Shown on the order page and in the "how to pay" email · crypto only, no bank details</div>
            <button onClick={save} disabled={busy} data-testid="payment-instructions-save" className="bl-btn gold text-[10px] py-2 px-4 inline-flex items-center gap-2">
              {busy ? <Loader2 size={12} className="animate-spin" /> : "Save"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
